export const tokens = {
  textPrimaryBlue: "hsl(238, 29%, 16%)",
  textPrimaryRed: "hsl(14, 88%, 65%)",
  textNeutralVdark: "hsl(237, 12%, 33%)",
  textNeutralDark: "hsl(240, 6%, 50%)",
  bgViolet: "hsl(273, 75%, 66%)",
  bgBlue: "hsl(240, 73%, 65%)",
  dividerBlue: "hsl(240, 5%, 91%)",
}
